<div class="container mt-4">
    <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-8">
            <div class="card">
                <div class="card-body">
                    <div class="mb-2 text-center">
                        <i class="fa-sharp fa-regular fa-circle-check mt-2 mb-4"></i>
                        <div class="heading-md mb-4">Submission Successful</div>
                        <p class="caption-lg mb-5">
                            Your claim submission has been received and is being processed.
                            <br />
                            You will receive a confirmation email shortly.
                        </p>
                        <p>
                            If you have any questions or for more information, please contact us at:
                            <a class="no-wrap" href="mailto:trp&#64;dewarinsurance.com">trp&#64;dewarinsurance.com</a><br />
                            or call&nbsp;<a class="no-wrap" href="tel:6177741555">617-774-1555.</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
